import angular from 'angular';
import errorComponent from './error.component';
import errorService from './error.service';


const errorModule = angular.module('error', [])
  .component('error', errorComponent)
  .service('errorService', errorService)
  .name;

export default errorModule;



// WEBPACK FOOTER //
// ./client/app/components/error/error.js